import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { Check, Circle, LoaderCircle, TriangleAlert, X } from 'lucide-react';
import { OverlayReadinessStatus } from 'modules/overlay-v2/domain/interfaces/readiness';
import React from 'react';
import { MessageDescriptor } from 'shared/i18n';

import { StatusBadge } from './styles';

interface StatusIconProps {
  status: OverlayReadinessStatus;
}

/** Подписи для скринридера и для тестов: по иконке статус шага иначе не прочитать. */
const STATUS_LABELS: Record<OverlayReadinessStatus, MessageDescriptor> = {
  pending: msg({ message: 'ожидает', context: 'readiness step status' }),
  running: msg({ message: 'выполняется', context: 'readiness step status' }),
  done: msg({ message: 'готово', context: 'readiness step status' }),
  warning: msg({ message: 'с оговоркой', context: 'readiness step status' }),
  failed: msg({ message: 'не получилось', context: 'readiness step status' }),
};

const ICONS: Record<OverlayReadinessStatus, typeof Check> = {
  pending: Circle,
  running: LoaderCircle,
  done: Check,
  warning: TriangleAlert,
  failed: X,
};

function StatusIcon({ status }: StatusIconProps) {
  const { t } = useLingui();
  const Icon = ICONS[status];

  return (
    <StatusBadge className={status} stepStatus={status} role={'img'} aria-label={t(STATUS_LABELS[status])}>
      <Icon strokeWidth={status === 'done' ? 3 : 2} />
    </StatusBadge>
  );
}

export default React.memo(StatusIcon);
